import React from "react";
import snowWhiteFacialImg from "./../../../../Images/FacialPage/Snow White Facial.png";

const SnowWhiteFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={snowWhiteFacialImg} alt="snowWhiteFacialImg" />
    </div>
  );
};

export default SnowWhiteFacialImg;
